module.exports = __webpack_public_path__ + "img/icon4.37afbed3.png";